/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

export default class ContentBundleGetService extends BaseService {
  constructor() {
    super(constants.CONTENT_BUNDLE_FETCHED, 'contentBundleStatus');
  }

  handleEvent(eventName, event) {
    if (event.bookId) {
      return this.getClient('evergreen').get(`/contentbundle?bookId=${event.bookId}`);
    }
    return null;
  }

  handleResponse(response, event) {
    // eslint-disable-line class-methods-use-this
    const { status, data } = response || {};
    if (event.bookId && status === 200 && data) {
      const payload = data.toc || data.contentBundle ? data : data.data || data;
      const store = Framework.getStoreRegistry().getStore('contentBundleState');
      store.setBundles(this.mapResponse(payload));
      store.setTocData(this.mapTocData(payload));
      store.setLastUpdated();
    }
  }

  mapResponse(data) {
    // eslint-disable-line class-methods-use-this
    const raw = data.contentBundle || (Array.isArray(data) ? data : []);
    if (!Array.isArray(raw)) return [];
    return raw.map((item) => {
      let bundleUri = [];
      if (Array.isArray(item.bundleUri)) bundleUri = item.bundleUri.map(String);
      else if (Array.isArray(item.bundle_uri)) bundleUri = item.bundle_uri.map(String);
      const str = (val) => (val != null ? String(val) : null);
      return {
        globalBookId: str(item.globalBookId ?? item.global_book_id),
        bookId: str(item.bookId ?? item.book_id),
        bundleLabel: str(item.bundleLabel ?? item.bundle_label),
        bundleUri,
        createdBy: str(item.createdBy ?? item.created_by),
        bundleId: str(item.bundleId ?? item.bundle_id),
        startPointTitle: str(item.startPointTitle ?? item.start_point_title),
        endPointTitle: str(item.endPointTitle ?? item.end_point_title)
      };
    });
  }

  mapTocData(data) {
    // eslint-disable-line class-methods-use-this
    const toc = data.toc || (data.data && data.data.toc);
    if (Array.isArray(toc) && toc.length > 0) return toc;
    if (data.jsonObj && Array.isArray(data.jsonObj)) return data.jsonObj;
    if (Array.isArray(data) && data.length > 0 && data[0] && (data[0].href != null || data[0].title != null)) {
      return data;
    }
    return [];
  }
}
